import React, { useState, useEffect } from "react";
import Grid from "@mui/material/Grid";
//import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import Checkbox from "@mui/material/Checkbox";
import Button from "@mui/material/Button";
import Paper from "@mui/material/Paper";
import { Typography, useMediaQuery } from "@mui/material";
import { useDispatch } from "react-redux";
import { setScDSA } from "./editScenarioNewSlice";
import { FixedSizeList as List } from 'react-window';
import InfiniteLoader from 'react-window-infinite-loader';
import AutoSizer from 'react-virtualized-auto-sizer';
import CustomButton from "../../../components/ui/CustomButton";

const addBtnText = "Add >";
const addAllBtnText = "Add All >>";
const remBtnText = "< Remove";
const remAllBtnText = "<< Remove All";

function not(a, b) {
	return a.filter((value) => b.indexOf(value) === -1);
}

function intersection(a, b) {
	return a.filter((value) => b.indexOf(value) !== -1);
}

export default function TransferListDSA({
	leftList,
	rightList,
	scDSAInd,
	attrIndex,
	selectedPG_SKU_ADSs,
	selectedPG_SKU_ADSsID,
	datasourceid,
	attributeName,
	isDisable
}) {
	const [checked, setChecked] = useState([]);
	const [left, setLeft] = useState([]);
	const [right, setRight] = useState([]);
	const [countLeft, setCountLeft] = useState(0);
	const [countRight, setCountRight] = useState(0);

	const leftChecked = intersection(checked, left);
	const rightChecked = intersection(checked, right);
	const [boxWidth, setBoxWidth] = useState(24);
	const isTab = useMediaQuery("(max-width: 800px)");

	const dispatch = useDispatch();
	useEffect(()=>{
		const updateZoomLevel = () => {
			const zoom = window.devicePixelRatio || 1;
			if(zoom <= 1){
				let l = 31;
				setBoxWidth(l);
			}else if (zoom > 1 && zoom <= 1.25){
				setBoxWidth(30);
			}else if (zoom > 1.25 && zoom < 1.5){
				let l = 27;
				setBoxWidth(l);
			}else if (zoom == 1.5){
				setBoxWidth(26);
			}else if (zoom > 1.5 && zoom <= 2){
				setBoxWidth(26);
			}else if( zoom > 2){
				setBoxWidth(50);
			}
		}
		updateZoomLevel();
		window.addEventListener('resize', updateZoomLevel);
		return () => {
			window.removeEventListener('resize', updateZoomLevel);
		}
	}, [window.devicePixelRatio, isTab]);

	useEffect(() => {
		if (leftList?.length >= 0) {
			setLeft(leftList);
		}
		if (rightList?.length >= 0) {
			setRight(rightList);
		}
	}, [leftList, rightList]);

	useEffect(() => {
		setCountLeft(left.length);
		setCountRight(right.length);
	}, [left, right]);

	const handleToggle = (value) => () => {
		setTimeout(() => {
			const currentIndex = checked.indexOf(value);
			const newChecked = [...checked];

			if (currentIndex === -1) {
				newChecked.push(value);
			} else {
				newChecked.splice(currentIndex, 1);
			}

			setChecked(newChecked);
		},10);
	};

	const handleAllRight = () => {
		const tempRight = right.concat(left);
		setRight(tempRight);
		setLeft([]);

		dispatch(setScDSA(scDSAInd, attrIndex, [], false,datasourceid,attributeName));
		dispatch(setScDSA(scDSAInd, attrIndex, tempRight, true,datasourceid,attributeName));
	};

	const handleCheckedRight = () => {
		const tempRight = right.concat(leftChecked);
		const tempLeft = not(left, leftChecked);
		setRight(tempRight);
		setLeft(tempLeft);
		setChecked(not(checked, leftChecked));

		dispatch(setScDSA(scDSAInd, attrIndex, tempLeft, false,datasourceid,attributeName));
		dispatch(setScDSA(scDSAInd, attrIndex, tempRight, true,datasourceid,attributeName));
	};

	const handleCheckedLeft = () => {
		const tempLeft = left.concat(rightChecked);
		const tempRight = not(right, rightChecked);
		setLeft(tempLeft);
		setRight(tempRight);
		setChecked(not(checked, rightChecked));

		dispatch(setScDSA(scDSAInd, attrIndex, tempLeft, false,datasourceid,attributeName));
		dispatch(setScDSA(scDSAInd, attrIndex, tempRight, true,datasourceid,attributeName));
	};

	const handleAllLeft = () => {
		const tempLeft = left.concat(right);
		setLeft(tempLeft);
		setRight([]);

		dispatch(setScDSA(scDSAInd, attrIndex, tempLeft, false,datasourceid,attributeName));
		dispatch(setScDSA(scDSAInd, attrIndex, [], true,datasourceid,attributeName));
	};

	const handleDoubleClick = (item, side) =>{
		if(side === "left"){
			const tempRight = right.concat(item);
			let leftlist = JSON.parse(JSON.stringify(left));
			const tempLeft  = leftlist.filter(x => x != item);
			setLeft(tempLeft);
			setRight(tempRight);
			setChecked(not(checked, item));
			dispatch(setScDSA(scDSAInd, attrIndex, tempLeft, false,datasourceid,attributeName));
			dispatch(setScDSA(scDSAInd, attrIndex, tempRight, true,datasourceid,attributeName));
		}else{
			const tempLeft = left.concat(item);
			let rightlist = JSON.parse(JSON.stringify(right));
			const tempRight  = rightlist.filter(x => x != item);
			setRight(tempRight);
			setLeft(tempLeft);
			setChecked(not(checked, item));
			dispatch(setScDSA(scDSAInd, attrIndex, tempLeft, false,datasourceid,attributeName));
			dispatch(setScDSA(scDSAInd, attrIndex, tempRight, true,datasourceid,attributeName));
		}
	}

	const customList = (items, count, side) => {
        const isItemLoaded = index => !!items[index];
        const loadMoreItems = (startIndex, stopIndex) => {
            return new Promise(resolve => {
                setTimeout(resolve, 1000); // Example delay to simulate fetching data
            });
        };

        return (
            <React.Fragment>
                <Typography sx={{ mt: 1, mb: 1 }} variant="subtitle2">Count: {count}</Typography>
                <Paper className="transferList"
                    sx={{ width: `${boxWidth}vw`, height: 200, overflowY: "auto", overflowX: "none", justifyContent: "space-between", border: "1px solid #c6c6c6" }}
                >
                    <InfiniteLoader
                        isItemLoaded={isItemLoaded}
                        itemCount={items.length}
                        loadMoreItems={loadMoreItems}
                    >
                        {({ onItemsRendered, ref }) => (
                            <AutoSizer>
                                {({ height, width }) => (
                                    <List
                                        ref={ref}
                                        height={195}
                                        width={`${boxWidth-0.2}vw`}
                                        itemCount={items.length}
                                        itemSize={40}
                                        style={{ overflowY: 'auto', overflowX: 'hidden', whiteSpace: 'nowrap', textOverflow: 'ellipsis' }}
                                        onItemsRendered={onItemsRendered}
                                    >
                                        {({ index, style }) => {
                                            const item = items[index];
                                            const labelId = `transfer-list-item-${item?.customerID}-label`;

                                            return item ? (
 
                                                <ListItem
                                                    key={index}
                                                    role="listitem"
													sx={{height: "32px", marginTop: .5,}}																	 
                                                    button
                                                    selected={checked.indexOf(item) !== -1}
                                                    style={{ ...style, backgroundColor: checked.includes(item) ? '#f2f1ed' : '' ,
														pointerEvents: isDisable ? 'none' : 'auto', // Disable interaction based on the variable
														opacity: isDisable ? 0.6 : 1,              // Change appearance based on the variable
													}}
                                                    onClick={handleToggle(item)}
													onDoubleClick={() => handleDoubleClick(item, side)}
                                                >
                                                    <ListItemIcon>
                                                        <Checkbox
                                                            checked={checked.indexOf(item) !== -1}
															onClick={handleToggle(item)}									   
                                                            tabIndex={-1}
                                                            disableRipple
                                                        />
                                                    </ListItemIcon>
                                                    <ListItemText
                                                        id={labelId}
                                                        primary={item}
														sx = {{"& .css-ookep8-MuiTypography-root": {fontSize: "0.9rem"}}}
                                                    />
                                                </ListItem>
                                            ) : (
                                                <ListItem style={style} />
                                            );
                                        }}
                                    </List>
                                )}
                            </AutoSizer>
                        )}
                    </InfiniteLoader>
                </Paper>
            </React.Fragment>
        );
    };

	return (
		<Grid container spacing={2} justifyContent="space-between" alignItems="center">
			<Grid item>{customList(left, countLeft, "left")}</Grid>
			<Grid item sx={{marginTop : "30px"}}>
				<Grid container direction="column" alignItems="center">
					<CustomButton
						sx={{ my: 0.5,  
							bgcolor: "grey.lighter",
							color: "#001489",
							width:"100%",
							// height: "40px",
							// fontSize: "14px",
							boxShadow: "none",
							"&:hover": {
							  bgcolor: "#001489",
							  color: "white.main",
							  border:"none",
							},   
						}}
						//variant="outlined"
						size="small"
						onClick={handleAllRight}
						disabled={left.length === 0 || isDisable}
						aria-label="move all right"
					>
						{addAllBtnText}
					</CustomButton>
					<CustomButton
						sx={{ my: 0.5,  
							bgcolor: "grey.lighter",
							color: "#001489",
							width:"100%",
							// height: "40px",
							// fontSize: "14px",
							boxShadow: "none",
							"&:hover": {
							  bgcolor: "#001489",
							  color: "white.main",
							  border:"none",
							},   
						}}
						//variant="outlined"
						size="small"
						onClick={handleCheckedRight}
						disabled={leftChecked.length === 0 || isDisable}
						aria-label="move selected right"
					>
						{addBtnText}
					</CustomButton>
					<CustomButton
						sx={{ my: 0.5,  
							bgcolor: "grey.lighter",
							color: "#001489",
							width:"100%",
							// height: "40px",
							// fontSize: "14px",
							boxShadow: "none",
							"&:hover": {
							  bgcolor: "#001489",
							  color: "white.main",
							  border:"none",
							},   
						}}
						//variant="outlined"
						size="small"
						onClick={handleCheckedLeft}
						disabled={rightChecked.length === 0 || isDisable}
						aria-label="move selected left"
					>
						{remBtnText}
					</CustomButton>
					<CustomButton
						sx={{ my: 0.5,  
							bgcolor: "grey.lighter",
							color: "#001489",
							width:"100%",
							// height: "40px",
							// fontSize: "14px",
							boxShadow: "none",
							"&:hover": {
							  bgcolor: "#001489",
							  color: "white.main",
							  border:"none",
							},   
						}}
						//variant="outlined"
						size="small"
						onClick={handleAllLeft}
						disabled={right.length === 0 || isDisable}
						aria-label="move all left"
					>
						{remAllBtnText}
					</CustomButton>
				</Grid>
			</Grid>
			<Grid item>{customList(right, countRight, "right")}</Grid>
		</Grid>
	);
}
